import { createStyles } from '@material-ui/core';

export const styles = () =>
  createStyles({
    root: {
      cursor: 'pointer',
    },
    rootDisabled: {
      cursor: 'default',
      pointerEvents: 'none',
    },
  });
